import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ContentSections from './components/ContentSections';
import ArticleSection from './components/ArticleSection';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://sugargoospread.help';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': 'Sugargoo Spreadsheet Hub',
  'url': siteUrl,
  'description': 'The ultimate Sugargoo Spreadsheet resource hub with updated product finds, shopping guides, shipping information, warehouse tips, reviews, coupon codes, and safety strategies for smarter international shopping.',
  'inLanguage': 'en',
  'potentialAction': {
    '@type': 'SearchAction',
    'target': `${siteUrl}/?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  'name': 'Sugargoo Spreadsheet Hub',
  'url': siteUrl,
  'logo': 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
  'description': 'Independent informational resource providing comprehensive Sugargoo Spreadsheet guides, reviews, and shopping resources.',
};

export default function Home() {
  return (
    <main>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}></script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}></script>
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <ContentSections />
      <ArticleSection />
      <CTABanner />
      <Footer />
    </main>
  );
}